/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: AppTable
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 11Feb2022 craig File created.
 \******************************************************************************/
import React from "react";
import {Container, Row, Col, Accordion} from "react-bootstrap";
import {ITeamUserLinkage} from "../models/application/IApplication";
import AccordionItem from "react-bootstrap/AccordionItem";
import AccordionHeader from "react-bootstrap/AccordionHeader";
import AccordionBody from "react-bootstrap/AccordionBody";


export const AppTable = (linkages?: ITeamUserLinkage[] | undefined) => {

    const buildDate = (d:Date | undefined) => {
        if (d !== undefined) {
            return new Date(d).toLocaleDateString('en-us', {weekday:"long", year:"numeric", month:"short", day:"numeric"});
        }
        return "";
    }
    if (linkages === undefined || linkages.length === 0) {
        return (
            <Container>
                <Row>
                    <Col>No teams found</Col>
                </Row>
            </Container>
        )
    }
    return (
        <Accordion defaultActiveKey="0" flush>
            <AccordionItem eventKey={"1"}>
                <AccordionHeader>Assigned Teams</AccordionHeader>
                <AccordionBody>
                    <Container>
                        <Row className="header-container">
                            <Col>Name</Col>
                            <Col>Start Date</Col>
                            <Col>End Date</Col>
                            <Col>Group Date</Col>
                        </Row>
                        {linkages?.map((linkage: ITeamUserLinkage) => (
                            <Row key={linkage.Team?.TeamName}>
                                <Col>{linkage.Team?.TeamName}</Col>
                                <Col>{buildDate(linkage?.Team?.StartDate)}</Col>
                                <Col>{buildDate(linkage.Team?.EndDate)}</Col>
                                <Col>{buildDate(linkage.Team?.GroupDate)}</Col>
                            </Row>
                        ))}
                    </Container>
                </AccordionBody>
            </AccordionItem>
        </Accordion>
    )
}

